import { useRouter } from 'next/router'
import { WORKSPACE_TAB } from 'ui-components'

import { Billing } from './Billing'
import { Maps } from './Maps'
import { Members } from './Members'
import { Settings } from './Settings'
import { Upgrade } from './Upgrade'

import { useIsWorkspaceMember } from '~workspace/hooks/useIsWorkspaceMember'
import { useIsWorkspaceOwner } from '~workspace/hooks/useIsWorkspaceOwner'

const Tab = () => {
  const {
    query: { tab = WORKSPACE_TAB.MAPS }
  } = useRouter()

  const isWorkspaceOwner = useIsWorkspaceOwner()
  const isWorkspaceMember = useIsWorkspaceMember()

  return (
    <>
      {tab === WORKSPACE_TAB.MAPS && <Maps />}
      {tab === WORKSPACE_TAB.MEMBERS && isWorkspaceMember && <Members />}
      {tab === WORKSPACE_TAB.SETTINGS && isWorkspaceOwner && <Settings />}
      {tab === WORKSPACE_TAB.UPGRADE && isWorkspaceOwner && <Upgrade />}
      {tab === WORKSPACE_TAB.BILLING && isWorkspaceOwner && <Billing />}
    </>
  )
}

export { Tab }
